<!-- <div style="    margin: 0% 3%;margin-bottom:10px"> -->
@if(isResetFlyout()) {
<!-- <mat-card appearance="outlined" style="border-radius: 10px !important;
    border-color: grey !important;    padding: 2% 0%;"> -->
<mat-card-header style="display: block;    padding: 0px 16px 0;">
    <div style="    display: flex;
    justify-content: end;">
        <button matButton="filled" mat-raised-button color="primary" (click)="onRowClick(this.appData,true)"
            class="cp-btn-submit"> <mat-icon> add</mat-icon> Add
        </button>
    </div>
</mat-card-header>
<mat-card-content style="padding-bottom: 0px !important;">
    <div class="mat-elevation-z8" style="box-shadow: none;" class="table-container">

        <table mat-table [dataSource]="dataSourceUI" multiTemplateDataRows class="grouped-table">
            <ng-container matColumnDef="group-app">
                <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="group-row level-1 ">
                    <button mat-icon-button class="toggle-btn" [attr.aria-label]="'Toggle ' + row.app"
                        (click)="toggleGroup(row)">
                        <mat-icon>{{ row.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                    <strong>App:</strong> {{ row.app }}
                    <button mat-icon-button class="clickable toggle-btn" (click)="onPrimaryLeafClick(row)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="Type">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Type </th>
                <td mat-cell *matCellDef="let row"> {{ row.type }} </td>
            </ng-container>

            <ng-container matColumnDef="Placement">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Placement </th>
                <td mat-cell *matCellDef="let row"> {{ row.placement }} </td>
            </ng-container>

            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> Status </th>
                <td mat-cell *matCellDef="let row"> {{ row.isActive ? 'Active' : 'Inactive' }} </td>
            </ng-container>

            <ng-container matColumnDef="CPAMAppId">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> CPAM App ID </th>
                <td mat-cell *matCellDef="let row"> {{ row.cpamAppId }} </td>
            </ng-container>

            @if (!isMobile) {
            <ng-container matColumnDef="OktaSsoUrl">
                <th mat-header-cell *matHeaderCellDef class="sticky-header"> OKTA SSO URL </th>
                <td mat-cell *matCellDef="let row" class="okta-url-col okta-url-cell"> {{ row.oktaSsoUrl }}
                </td>
            </ng-container>
            }

            <!-- HEADER for leaf rows only -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <!-- LEVEL 1 GROUP ROW: references the 'group-app' column -->
            <tr mat-row *matRowDef="let row; columns: ['group-app']; when: isLevel1"></tr>

            <!-- LEVEL 2 GROUP ROW: references the 'group-type' column -->
            <!-- <tr mat-row *matRowDef="let row; columns: ['group-type']; when: isLevel2"></tr> -->

            <!-- LEAF ROW: references the leaf columns -->
            <tr mat-row *matRowDef=" let row; columns:
        displayedColumns; when: isLeafRow" class="leaf-row"></tr>

        </table>

    </div>
</mat-card-content>
<!-- </mat-card> -->
}
@else {
<app-add-edit-app [appData]="appData" [applicationList]="data" (onCancelClick)="onCancelHandle($event)"
    (onDataRefresh)="onDataRefresh($event)"></app-add-edit-app>
}

<!-- </div> -->